<template>
  <div>
    <!-- 数字产业·作物分布 -->
    <div class="crop_distribution">
      <div
        v-for="(item, index) in crop"
        :key="index"
        :class="item.Class"
        @click="click_crop(item.Class, index, item.cont)"
      >
        {{ item.cont }}
      </div>
      <div class="datasSreening" @click="dataDetail()">数据总览</div>
    </div>
    <!-- 数据总览弹框 -->
    <div>
      <el-dialog
        :visible.sync="dialogVisible"
        width="55%"
        :modal="moadl"
        :close-on-click-modal="false"
        :show-close="false"
        :destroy-on-close="true"
        center
      >
        <span slot="title">
          <img :src="f_font_two" alt="" class="dialog-title" />
        </span>
        <img
          :src="detail_icon_one"
          alt=""
          class="close-icon"
          @click="dialogVisible = false"
        />
        <div>
          <DetailData></DetailData>
        </div>
      </el-dialog>
    </div>
  </div>
</template>

<script>
import DetailData from "./details/detail_data.vue";
export default {
  name: "crop_distribution",
  components: {
    DetailData,
  },
  data() {
    return {
      crop: [
        {
          Class: "cont_dp",
          cont: "大棚",
          boolen_val: false,
        },
        {
          Class: "cont_mx",
          cont: "苜蓿",
          boolen_val: false,
        },
        {
          Class: "cont_sc",
          cont: "蔬菜",
          boolen_val: false,
        },
        {
          Class: "cont_sd",
          cont: "水稻",
          boolen_val: false,
        },
        {
          Class: "cont_td",
          cont: "土豆",
          boolen_val: false,
        },
        {
          Class: "cont_xm",
          cont: "小麦",
          boolen_val: false,
        },
        {
          Class: "cont_xx",
          cont: "小麦/苜蓿",
          boolen_val: false,
        },
        {
          Class: "cont_xy",
          cont: "小麦/玉米",
          boolen_val: false,
        },
        {
          Class: "cont_ym",
          cont: "玉米",
          boolen_val: false,
        },
      ],
      moadl: false,
      dialogVisible: false,
      f_font_two: require("@/assets/crop_distribution/数据总览字.png"),
      detail_icon_one: require("@/assets/images/路径 28736_2@2x.png"),
    };
  },
  methods: {
    load() {
      var height = document.body.clientHeight / 2;
      $(".crop_distribution").css("top", height + "px");
    },
    click_crop: function (Class, e, name) {
      this.crop[e].boolen_val = !this.crop[e].boolen_val;
      let vnt = this.crop[e].boolen_val;
      let vn = !this.crop[e].boolen_val;
      if (vnt) {
        plMap.visibleDigitalIndustrial_LegendLayer(
          plMap.digitalIndustrial.curLayerId,
          e
        );
        $(".crop_distribution").children().css("border", "1px solid #fff");
        $("." + Class).css("border", "3px solid #f00");
        this.$set(this.crop, "boolen_val", false);
      }
      if (vn) {
        plMap.visibleDigitalIndustrial_LegendLayer(
          plMap.digitalIndustrial.curLayerId,
          e
        );
        $(".crop_distribution").children().css("border", "1px solid #fff");
        this.$set(this.crop, "boolen_val", true);
        plMap.removeDigitalIndustrial_LegendLayer();
      }
    },
    dataDetail() {
      this.dialogVisible = true;
    },
  },
  mounted: function () {
    this.load();
  },
};
</script>

<style scoped lang="less">
.crop_distribution {
  position: absolute;
  right: 1%;
  transform: translate(0, -50%);
}
.cont_dp,
.cont_ym,
.cont_ym,
.cont_xy,
.cont_xx,
.cont_xm,
.cont_td,
.cont_sd,
.cont_sc,
.cont_mx {
  cursor: pointer;
  width: 86px;
  height: 40px;
  border: 1px solid #fff;
  margin: auto;
  margin-top: 5px;
  margin-bottom: 5px;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
}
.datasSreening {
  cursor: pointer;
  width: 100px;
  height: 40px;
  border: 1px solid #fff;
  margin: auto;
  margin-top: 5px;
  margin-bottom: 5px;
  color: #fff;
  text-align: center;
  line-height: 40px;
  border-radius: 5px;
  text-align: center;
  letter-spacing: 4px;
  font-size: 14px;
  background: url("../../assets/crop_distribution/数据总览.png");
  background-size: 100% 100%;
  background-repeat: no-repeat;
}
.cont_dp {
  background: url("../../assets/crop_distribution/大棚.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_mx {
  background: url("../../assets/crop_distribution/苜蓿.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_sc {
  background: url("../../assets/crop_distribution/蔬菜.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_sd {
  background: url("../../assets/crop_distribution/水稻.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_td {
  background: url("../../assets/crop_distribution/土豆.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_xm {
  background: url("../../assets/crop_distribution/小麦.png");
  background-size: 110% 100%;
  background-repeat: no-repeat;
}
.cont_xx {
  background-size: 110% 100%;
  background-repeat: no-repeat;
  background: url("../../assets/crop_distribution/小麦_苜蓿.png");
}
.cont_xy {
  background-size: 110% 100%;
  background-repeat: no-repeat;
  background: url("../../assets/crop_distribution/小麦_玉米.png");
}
.cont_ym {
  background-size: 110% 100%;
  background-repeat: no-repeat;
  background: url("../../assets/crop_distribution/玉米.png");
}
.dialog-title1 {
  width: 210px;
  height: 40px;
}
.close-icon {
  width: 32px;
  height: 32px;
  position: absolute;
  top: 32px;
  right: 41px;
  cursor: pointer;
}
/deep/.el-dialog {
  background: #15606e;
  border: 1px solid rgb(43, 249, 252);
  margin-top: 17vh !important;
}
::-webkit-scrollbar {
  width: 5px;
} /* 这是针对缺省样式 (必须的) */
::-webkit-scrollbar-thumb {
  background: #0e4560;
  width: 5px;
  border-radius: 10px;
} /* 滑块颜色 */
/deep/.el-dialog--center .el-dialog__body {
  padding: 0 18px 20px;
}
</style>


// WEBPACK FOOTER //
// src/components/cutline/crop_distribution.vue